const langtrans={
      fhssyy:["返回上一页","Back"],
      ksjy:["开始救援","Starting service"],
      lcsy:["流程示意","Flow chart"],
      jyffwq:["救援服务清单","Service list"],
      kscczz:["开始操作","Start operation"],
      qjtjjd:["其他节点：","Other Nodes："],
	  qtjdjl:['其他节点记录','Other Node'],
      xgssym:["修改说明及相关单据","Specification of modificatioons and relevant documents"],
      xgjjdd:["修改节点成功","Modify node successfully"],
      xgjj:["修改节点","Modify node"],
      cczzzs:["操作说明：","specification of operation："],
      xxgdcs:["相关单据上传：","Upload relevant documents："],
      xzz:["下载","Download"],
      jywc:["救援完成","Assistance completed"],
      ajqx:["案件取消","Cancel case"],
      qrajqx:["确认取消该案件？","Confirm to cancel this case?"],
      xgdcwts:["相关单据必须上传五条","Please upload 5 relevant documents"],
      qx:["取消","Cancel"],
      qscwj:["请选择要上传的文件","Please select a file to upload"],
      scsb:["上传失败","Upload failed"],
      zwfjqxzj:["暂无附件，请在下方添加","No attachments yet, please add below"],
      ajcczz:["案件操作","Case operation"],
      tjcczz:["添加操作说明","Add Operation Specification:"],
      cczzzj:["操作进展","Operation progress"],
      tjfj:["添加附件","Attach files"],
      sc:["删除","Delete"],
      wcgccz:["完成该操作","Complete operation"],
      fjjssy:["附件及说明修改","Attachment and specification of modifications"],
      xgcczz:["修改操作说明","Specification of modification of operation"],
      wcxg:["完成修改","Finish modification"],
      fjmc:["附件名称","Attachment name"],
      xzwj:["选择文件","Select file"],
      ckfj:["查看","View"],
      xgtpmc:["修改名称","Rename"],
      qsrtpmc:["请输入图片名称","Please enter image name"],
      tpmcbnwk:["图片名称不能为空","Image name cannot be empty"],
      dwjcg:["单个文件不能超过20MB","Single file cannot exceed 20MB"],
      bqts:["选填，不填则使用文件名","Optional, filename is used if empty"],
      ljsxgd:["累计","Total"],
      tppmcc:["图片名称","Type of Images"],
      yldcsj:["医疗单据","Medical documents"],
      tppddz:["图片地址","Image location"],
      qd:["确定","Confirm"],
      wcjyaj:["完成救援案件","End of operation"],
      bjjj:["、报价","Quotation"],
      ztbtbj:["整体报价","Total"],
      jyfy:["救援费用","Operation fee"],
      ajfy:["案件费用","Case fee"],
      ylfy:["医疗费用","Medical cost"],
      sjfy:["、实际费用","、Actual cost"],
      qsrje:["请输入金额！","Please enter the amount"],
      qjtfy:["客户自费","Other cost"],
      qjtfys:["其他费用说明","Other cost"],
      qrtdsj:["确认提交","Confirm and submit"],
      tjjjdd:["添加节点","Add node"],
      tjjjdcg:["添加节点成功","Add node successfully"],
      qtjjjd:["请添加节点","Please add node"],
      tj:["添加","Add"],
      qrxg:["确认修改","Confirm modification"],
      qbbfyy:["请不要输入过多节点，默认显示五条","en_translated"],
      jjddmc:["节点名称不能为空！","The node name cannot be empty"],
      qsrsss:["请输入数字，而非其他","Please enter numbers only"],
      qwcsyy:["请完成所有操作！","Please complete all operations"],
      nrbbfn:["内容不能为空！","en_translated"],
      tjcg:["添加成功","Added successfully"],
      xgcg:["修改成功","The modification is successful"],
	  ajxq:["案件详情","Details of the case"],
	  khxm:["客户姓名","Name"],
	  ajh:["案件号","CaseId"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/resstep.vue.trans.js